import { NO_DECIMALS_COC } from '@/constants/common'
import NP from 'number-precision'

export const point2yuan = <T extends number | string | null | undefined>(price: T) => (price ? NP.divide(price, 100) : price)
export const yuan2Point = <T extends number | string | null | undefined>(price: T) => (price ? NP.times(price, 100) : price)

export const formatPrice = (price: number, currencyCode?: string) => {
  const price2Show = point2yuan(price)
  if (NO_DECIMALS_COC.includes(currencyCode)) {
    return `${currencyCode} ${price2Show.toFixed(0)}`
  }
  return `${currencyCode ?? ''} ${price2Show.toFixed(2)}`.trim()
}

/**
 * 把对象的其中几个key除以100
 * @param obj
 * @param keys
 * @returns
 */
export const point2yuanObj = (obj: any, ...keys: string[]) => {
  const res = { ...obj }
  keys.forEach((key) => (res[key] = point2yuan(obj[key])))
  return res
}
